import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram , Linkedin} from "lucide-react";
import { LOGO_URL } from "../data/projects";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, ADDRESS } from "../lib/whatsapp";

const INSTAGRAM_URL = "https://www.instagram.com/sanggavais.in";
const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61592777276149";
const LINKEDIN_URL = "https://www.linkedin.com/company/sanggavai-constructions-pvt-ltd/";
export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F0F10] text-white relative overflow-hidden">
      {/* Subtle brand accent */}
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full brand-gradient opacity-10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 h-80 w-80 rounded-full brand-gradient opacity-10 blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl pt-20 md:pt-28 pb-10 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          {/* Column 1: Logo + About */}
          <div className="md:col-span-5">
            <div
              data-testid="footer-logo-box"
              className="inline-block bg-white p-3 md:p-4 shadow-lg"
              style={{ borderRadius: "14px" }}
            >
              <img src={LOGO_URL} alt="Sanggavai's" className="h-14 md:h-16 w-auto object-contain" />
            </div>
            <p className="mt-7 font-serif text-2xl md:text-3xl leading-snug text-white">
              Sanggavai Constructions
            </p>
            <p className="mt-3 text-white/65 text-base md:text-lg leading-relaxed max-w-md">
              Crafting quality spaces that last. 34+ years of trusted construction.
            </p>

            {/* Socials */}
            <div className="mt-8 flex items-center gap-3">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="group h-11 w-11 rounded-full border border-white/20 flex items-center justify-center hover:border-transparent hover:brand-gradient transition-all duration-300"
              >
                <Instagram className="h-5 w-5 text-white/80 group-hover:text-white transition-colors" />
              </a>
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="group h-11 w-11 rounded-full border border-white/20 flex items-center justify-center hover:border-transparent hover:brand-gradient transition-all duration-300"
              >
                <Facebook className="h-5 w-5 text-white/80 group-hover:text-white transition-colors" />
              </a>
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="group h-11 w-11 rounded-full border border-white/20 flex items-center justify-center hover:border-transparent hover:brand-gradient transition-all duration-300"
              >
                <Linkedin className="h-5 w-5 text-white/80 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          {/* Column 2: Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.28em] uppercase text-white/50 mb-6">Explore</h4>
            <ul className="space-y-4 text-lg">
              <li><Link to="/about" className="text-white/80 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/projects" className="text-white/80 hover:text-white transition-colors">Projects</Link></li>
              <li><Link to="/careers" className="text-white/80 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="md:col-span-4">
            <h4 className="text-xs tracking-[0.28em] uppercase text-white/50 mb-6">Reach Us</h4>
            <ul className="space-y-5">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-0.5 shrink-0 text-[#E85D8E]" />
                <span className="text-white/80 leading-relaxed text-base">{ADDRESS}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 shrink-0 text-[#E85D8E]" />
                <a href={`tel:${PHONE_TEL}`} className="text-white/80 hover:text-white text-base" data-testid="footer-phone">{PHONE_DISPLAY}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 shrink-0 text-[#E85D8E]" />
                <a href={`mailto:${EMAIL}`} className="text-white/80 hover:text-white text-base" data-testid="footer-email">{EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <p data-testid="footer-copyright">© 2026 Sanggavai Constructions</p>
          <p data-testid="footer-tagline">Building Aspirations Since 1990</p>
        </div>
      </div>
    </footer>
  );
}
